const BaseModel = require('lib/base_model')
const log = require('log').create('model','interest') // eslint-disable-line

const Interest = BaseModel.extend({

    idAttribute: 'lowercase_interest',

    defaults: {
        interest: '',
    },

     
    constructor: function constructor(attrs, options) {
        // generate initial idAttribute value
        attrs[this.idAttribute] = this.generateId(attrs.interest)
        return BaseModel.apply(this, [attrs, options])
    },

    initialize() {
        // for safety, don't think interests actually change
        this.on('change:interest', (model, interest) => {
            this.set(this.idAttribute, this.generateId(interest))
        })
    },

    generateId(interest) {
        return (
            this.sanitize(interest || '')
                .toLowerCase()
                .trim()
                .replace(/ /g, '_')
        )
    },

    calculated_values: {
        hashtag() {
            let interest = this.get('lowercase')
            interest = interest.replace(/ /g, '')
            return `#${interest}`
        },
        lowercase() {
            const interest = this.get('interest') || ''
            return interest.toLowerCase()
        },
    },

    validate(attrs) {
        const interest = attrs.interest
        if (! interest || ! interest.length) return 'Interest required.'
    },

    // override model.set to sanitize input
    set() {
        const { attrs, options } = this.parseKeyValArguments.apply(this, arguments)

        if (attrs.interest) {
            attrs.interest = this.sanitize(attrs.interest)
        }

        BaseModel.prototype.set.apply(this, [attrs, options])
    },

    sanitize(value) {
        return (
            value
            // only alphanumeric, _, and -
                .replace(/[^a-z0-9À-ž_-\s]+/ig, '')
            // no double dashes or hypens or hyphen dashes or dash hyphens
                .replace(/[-|_](?=-|_)/g, '')
        )
    },

})

module.exports = Interest
